import React, { useState, useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';

const Checkboxes = props => {
  const {setMobileMenu, setTopMobileMenu, activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data, open, multi, handleClose, clearAllFilters, widget, single} = props;
  const elements = data.elements;
  let checked = [];


  data.elements.forEach(element => {
    if (activeFilters[data.name].value.indexOf(element.value) > -1){
      checked.push(true)
    } else {
      checked.push(false);
    }
  });

  const handleViewResults = () => {
    handleClose();
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav)
    setNavStatus(false);

    setMobileMenu(false);
    setTopMobileMenu(false);
    const body = document.querySelector('body');

    body.classList.remove('filters-open');


  }

  const clearTheseFilters = () => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    activeFilter.value = [];
    activeFilter.selectedTitles = [];

    setActiveFilters(a);
  }

  const handleChange = (position, val, title) => {
    const updatedCheckedState = checked.map((item, index) =>
      index === position ? !item : item
    );
    checked = updatedCheckedState;
    const filter = {...activeFilters[data.name]};
    if (filter.value.indexOf(val) > -1) {
      filter.value.splice(filter.value.indexOf(val), 1);
      filter.selectedTitles.splice(filter.selectedTitles.indexOf(title), 1);
    } else {
      filter.value.push(val);
      filter.selectedTitles.push(title);
    }
    setActiveFilters({...activeFilters,
      [data.name]: filter
    });

  }

  return (
    <div className={classnames('level-2', {
      active: open,
    })} >
    <div className="checkboxes" >


      <button className="filter-button filter-back" onClick={() => handleClose()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
          <path d="M8 13.5L2 7.5L8 1.5" stroke="black" stroke-width="2"/>
        </svg>
        Back
      </button>

      <div className="filter-title">{data.title}</div>
      <div className="form-element-section-items">
      {elements.map((element, i) => {
        return (
          <div className="form-element form-element-checkbox" key={data.name + '_' + i}>
            <input
              type="checkbox"
              id={data.name + '_' + i}
              name={data.name}
              value={element.value}
              checked={checked[i]}
              onChange={(e) => handleChange(i, e.target.value, element.title)}
            />
            <label htmlFor={data.name + '_' + i}>{element.title}</label>
          </div>
        )
      }

      )}
      </div>


    </div>
    <div className="filter-bottom">

      <button className="button button-black" onClick={() => handleViewResults()}>
        View results
      </button>
      <button className="filter-button filter-clear clear-all-filters button button-white-border" onClick={clearTheseFilters}>
        Reset these filters

      </button>
    </div>
    </div>
  )
}

export default Checkboxes;
